<app-header></app-header>
<main class="main-content">
  <router-outlet></router-outlet>
</main>
<app-footer></app-footer>
<app-chat-button></app-chat-button>
